import apiHandler from '../core/apiHandler';
export default apiHandler('restaurant/raw-material-categories');
